import React, { useEffect, useState } from 'react';
import { listenTeam } from '../firebase';
import Scoreboard from '../components/Scoreboard';

export default function PlayerTeam(){
  const [team, setTeam] = useState(null);
  const teamId = typeof window !== 'undefined' ? localStorage.getItem('teamId') : null;

  useEffect(()=>{
    if (!teamId) return;
    const unsub = listenTeam(teamId, setTeam);
    return () => unsub && unsub();
  }, [teamId]);


  const { t } = require('../i18n');

  if (!teamId) return (
    <div className="container py-4">
      <div className="alert alert-warning">{t('noTeamSelected')}</div>
    </div>
  );

  if (!team) return <div className="container py-4">{t('loadingTeam')}</div>;

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="card mb-3">
            <div className="card-body">
              <h4>{team.name}</h4>
              <div className="small text-muted">{t('points')}: {team.points || 0}</div>
              <hr />
              <h6>{t('members')}</h6>
              <ul>
                {team.members ? Object.entries(team.members).map(([uid, name]) => (
                  <li key={uid}>{name || uid}</li>
                )) : <li>{t('noMembersYet')}</li>}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-body">
              <h5>{t('scoreboard')}</h5>
              <Scoreboard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
